import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown';
import IconArrow from 'components/svg/IconArrow';
import styled from 'styled-components';

const Li = styled.li``;

const A = styled.a``;

/**
 * Renders menu items and call the dropdown component
 *
 * @param {object} menu object with the values of each menu item.
 * @param {number} index index of each item.
 * @param {object} show Object with the active value and index of the selected item.
 * @param {func} onClick used to pass the active state and index of the selected item.
 * @param {func} goBack used to pass the event to the parent, and run the reverse animation.
 */

const MenuItems = ({ menu, index, show, onClick, goBack }) => {
  return (
    <Li>
      {menu?.children?.length > 0 ? (
        <>
          <A href="#" onClick={() => onClick({ active: true, index })}>
            {menu?.label}
            <IconArrow />
          </A>
          {show.active && show.index === index && (
            <Dropdown
              show={show.active}
              submenu={menu?.children}
              goBack={goBack}
            />
          )}
        </>
      ) : (
        <A href={menu?.path} target={menu?._target}>
          {menu?.label}
        </A>
      )}
    </Li>
  );
};

MenuItems.propTypes = {
  menu: PropTypes.object,
  index: PropTypes.number,
  show: PropTypes.object,
  onClick: PropTypes.func,
  goBack: PropTypes.func,
};

export default MenuItems;
